export default __webpack_public_path__ + "static/media/OffShelfPresentations.cbfab7a5.JPG";